module.exports = __webpack_public_path__ + "assets/heart-76df852fd8a6b174baa701bbba3dd725.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/data/images/heart.jpg
// module id = 515
// module chunks = 1